export default {
  ControleEquipementSection: {
    title: {
      fr: "Controlez vos équipements",
      en: "ontrol your equipment",
    },
    subtitle: {
      fr: "Un seul système pour piloter tous les équipements de votre bâtiment.",
      en: "One system to control all your building equipment.",
    },
    features: {
      title: {
        fr: "",
        en: "",
      },
      items: {
        mutlizone: {
          title: {
            fr: "GAINABLE",
            en: "DUCTED",
          },
          description: {
            fr: "",
            en: "",
          },
        },
        splits: {
          title: {
            fr: "CASSETTE",
            en: "SPLITS",
          },
          description: {
            fr: "",
            en: "",
          },
        },
        radiator: {
          title: {
            fr: "RADIATEUR",
            en: "RADIATOR",
          },
          description: {
            fr: "",
            en: "",
          },
        },
        lights: {
          title: {
            fr: "ECLAIRAGE",
            en: "LIGHTING",
          },
          description: {
            fr: "",
            en: "",
          },
        },
        shades: {
          title: {
            fr: "OCCULTANT",
            en: "SHADES",
          },
          description: {
            fr: "",
            en: "",
          },
        },
        IRVE: {
          title: {
            fr: "IRVE",
            en: "IRVE",
          },
          description: {
            fr: "",
            en: "",
          },
        },
      },
    },
    screens: {
      mapAndThermostat: {
        title: {
          fr: "Le bon confort, dans chaque zone",
          en: "The right comfort in every zone",
        },
        subtitle: {
          fr: "Visualisez les températures et ajustez les consignes, sur place ou à distance.",
          en: "View temperatures and adjust setpoints, on site or remotely.",
        },
      },
      CTA: {
        title: {
          fr: "Maîtrisez la qualité de l’air intérieur",
          en: "Take control of indoor air quality",
        },
        subtitle: {
          fr: "mesurez, pilotez et adaptez la ventilation.",
          en: "monitor, control and adjust ventilation.",
        },
      },
      blockCVC: {
        title: {
          fr: "Autorisez des dérogations de consignes",
          en: "Allow setpoint overrides",
        },
        subtitle: {
          fr: "et accompagnez la conduite du changement.",
          en: "and drive change management.",
        },
      },
      history: {
        title: {
          fr: "Accédez aux données historiques en temps réel",
          en: "Access real-time historical insights",
        },
        subtitle: {
          fr: "sur l’ensemble de vos équipements et de leurs paramètres.",
          en: "across all equipment and settings.",
        },
      },
    },
  },
};
